export const steps = [
  {
    id: 1,
    title: "Connect Amazon Accounts",
    sub: true,
    link: true,
    dots: ["dot-1a", "dot-1b"],
  },
  { id: "dot-1a", type: "dot", parentStep: 1 },
  { id: "dot-1b", type: "dot", parentStep: 1 },
  {
    id: 2,
    title: "Add COGS to get ASIN level ROI",
    link: true,
  },
  {
    id: 3,
    title: "Check MI Insights",
    sub: true,
    link: true,
    dots: ["dot-3a", "dot-3b"],
  },
  { id: "dot-3a", type: "dot", parentStep: 3 },
  { id: "dot-3b", type: "dot", parentStep: 3 },
  {
    id: 4,
    title: "Setup market share goal",
    sub: true,
    link: true,
  },
  { id: "?", title: "What’s next?" },
];
